<template>
  <div style="background-color: #fafafa">
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <!--新合同-->
      <van-list
        v-if="this.dynamicTab.builtin === 'receivableOrder' && this.advisorId"
        v-model="loading"
        :finished="finished"
        @load="onLoad"
        finished-text="没有更多了"
      >
        <div
          v-for="form in list"
          :key="form.uuid"
          class="card"
          @click="openOrder(form.uuid, form.workflowTemplateId, form.status)"
        >
          <table class="layout">
            <tr>
              <td class="title" colspan="2">
                <span class="iconfont icon-money-rmb"></span>{{ form.amount }}
              </td>
              <td class="content" style="text-align: right">
                {{ form.createTime }}
              </td>
            </tr>
            <tr>
              <td class="content" colspan="3">
                合同内容：{{ form.summaryInfo || "" }}
              </td>
            </tr>
            <tr>
              <td>
                <span v-if="form.status === '已保存'">{{ form.status }}</span>
                <span
                  v-if="form.status === '意外终止'"
                  style="color: #d4825b"
                  >{{ form.status }}</span
                >
                <span v-if="form.status === '审批中'" style="color: #2d7fc7">{{
                  form.status
                }}</span>
                <span v-if="form.status === '执行中'" style="color: #66cc66">{{
                  form.status
                }}</span>
                <span v-if="form.status === '已结束'" style="color: #abb5b8">{{
                  form.status
                }}</span>
                <span
                  v-if="form.status === '审批驳回'"
                  style="color: #ff3300"
                  >{{ form.status }}</span
                >
              </td>
              <td class="td-btn-container" colspan="2">
                <van-list v-if="form.status === '执行中'">
                  <template
                    v-if="form.creatableForms && form.creatableForms.length > 0"
                  >
                    <span v-for="tab in form.creatableForms" :key="tab.uuid">
                      <template
                        v-if="
                          (userId === advisorId ||
                            sharePermissions.indexOf(tab.workflowTemplateId) >
                              -1) &&
                          tab.isCreatable
                        "
                      >
                        <van-button
                          class="btn-create-from"
                          round
                          size="small"
                          type="info"
                          @click="
                            createForm(
                              tab.workflowTemplateId,
                              form[tab.uuid],
                              $event
                            )
                          "
                        >
                          录入{{ tab.formName }}
                        </van-button>
                      </template>
                    </span>
                  </template>
                </van-list>
              </td>
            </tr>
          </table>
        </div>
      </van-list>
      <!--其他-->
      <van-list
        v-if="this.dynamicTab.builtin !== 'receivableOrder'"
        v-model="loading"
        :finished="finished"
        @load="onLoad"
        finished-text="没有更多了"
      >
        <div
          v-for="form in list"
          :key="form.uuid"
          class="card"
          @click="openForm(form.uuid, form.workflowTemplateId)"
        >
          <table class="layout" v-if="dynamicTab.workflowTemplateId">
            <tr>
              <td colspan="2">
                <span class="title">单号：{{ form.serialNumber }}</span>
              </td>
              <td class="content" style="text-align: right">
                {{ form.createTime }}
              </td>
            </tr>
            <tr>
              <td class="content" colspan="2">
                当前状态：{{ form.currentState || "" }}
              </td>
              <td></td>
            </tr>
            <!--订单、工单、收款单、合同-->
            <tr
              v-if="
                dynamicTab.builtin === 'order' ||
                dynamicTab.builtin === 'receipt' ||
                dynamicTab.builtin === 'workorder' ||
                dynamicTab.builtin === 'contract'
              "
            >
              <td class="content">金额：{{ form.amount }}</td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td class="td-btn-container" colspan="3">
                <template
                  v-if="form.creatableForms && form.creatableForms.length > 0"
                >
                  <span v-for="tab in form.creatableForms" :key="tab.uuid">
                    <template
                      v-if="
                        (userId === advisorId ||
                          sharePermissions.indexOf(tab.workflowTemplateId) >
                            -1) &&
                        tab.isCreatable
                      "
                    >
                      <van-button
                        class="btn-create-from"
                        round
                        size="small"
                        type="info"
                        @click="
                          createForm(
                            tab.workflowTemplateId,
                            form[tab.uuid],
                            $event
                          )
                        "
                      >
                        录入{{ tab.formName }}
                      </van-button>
                    </template>
                  </span>
                </template>
              </td>
            </tr>
          </table>
          <table class="layout" v-if="!dynamicTab.workflowTemplateId">
            <template>
              <tr v-for="field in displayField" :key="field.fieldName">
                <td>{{ field.fieldShowName }}</td>
                <td>
                  {{
                    form[
                      field.dictionary
                        ? field.fieldName + "name"
                        : field.fieldName
                    ] || "无"
                  }}
                </td>
              </tr>
            </template>
          </table>
        </div>
      </van-list>
    </van-pull-refresh>
    <van-popup v-model="showTableGrid" position="right">
      <van-nav-bar
        title="详情"
        left-text="返回"
        left-arrow
        @click-left="cancel"
      ></van-nav-bar>
      <table-grid
        v-if="showTableGrid"
        :table-name="dynamicTab.tableName"
        :data-id="tableGridId"
        :grouping="grouping"
        @savecomplate="cancel"
      >
      </table-grid>
    </van-popup>
  </div>
</template>

<script>
import { Button, List, Panel, Popup, PullRefresh, NavBar } from "vant";
import userInfo from "../store/userInfo";
import { getKey } from "../utils/url";
import formsService from "../service/formsService";
import customerService from "../service/customerService";
import moment from "moment";
import { formatMoney } from "../utils/money";
import { formatDictionary } from "../utils/dictionary";
import fieldDescriptionService from "../service/fieldDescriptionService";

export default {
  data: function () {
    return {
      list: [],
      creatableForms: [],
      dynamicTab: {},
      displayField: [],
      loading: false,
      showTableGrid: false,
      tableGridId: "",
      finished: false,
      pageIndex: 0,
      customerId: "",
      dynamicTabId: "",
      grouping: false,
      advisorId: "",
      sharePermissions: "",
      refreshing: false,
    };
  },
  store: userInfo,
  components: {
    [Button.name]: Button,
    [Panel.name]: Panel,
    [List.name]: List,
    [Popup.name]: Popup,
    [NavBar.name]: NavBar,
    [PullRefresh.name]: PullRefresh,
  },
  computed: {
    userId() {
      return this.$store.getters.getUserId;
    },
  },
  created: async function () {
    this.customerId = getKey("customerId");
    this.dynamicTabId = getKey("dynamicTabId");
  },
  methods: {
    async onLoad() {
      let resp = await formsService.getDynamicTabById(this.dynamicTabId);
      if (resp.data.Status === "1") {
        this.dynamicTab = resp.data.Data;
        let displayField = await fieldDescriptionService.getFieldDisplayOnAPP(
          resp.data.Data.tableName
        );
        if (displayField.data.Status === "1") {
          this.displayField = displayField.data.Data;
        }
        this.getFormDataListByCustomerId();
      }
      /**
       * 获取客户理财师
       */
      if (!this.advisorId) {
        let customerResp = await customerService.getById(this.customerId);
        if (customerResp.data.Status === "1") {
          this.advisorId = customerResp.data.Data.advisorId;
        }
      }
      /**
       * 获取共享权限
       */
      if (this.advisorId && this.advisorId !== this.userId) {
        let respShare = await customerService.getSharePermissions(
          this.customerId
        );
        if (respShare.data.Status === "1") {
          this.sharePermissions = respShare.data.Data;
        }
      }
    },
    /**
     * 获取表单数据
     */
    async getFormDataListByCustomerId() {
      this.pageIndex++;
      let dictionaryField = [];
      this.displayField
        .filter((field) => field.dictionary)
        .forEach((field) => {
          dictionaryField.push(field.fieldName + "." + field.dictionary);
        });
      let resp = await formsService.getFormDataListByCustomerId(
        this.pageIndex,
        this.dynamicTab.tableName,
        this.customerId,
        this.dynamicTab.workflowTemplateId,
        dictionaryField.join(",")
      );
      if (resp.data.Status === "1") {
        resp.data.Data.data.forEach((form) => {
          if (
            this.dynamicTab.builtin === "contract" ||
            this.dynamicTab.builtin === "receipt" ||
            this.dynamicTab.builtin === "order" ||
            this.dynamicTab.builtin === "receivableOrder"
          ) {
            form.amount = formatMoney(form.amount);
          } else if (this.dynamicTab.builtin === "workorder") {
            form.amount = formatMoney(form.balance);
          }
          this.dynamicTab.builtin === "receivableOrder"
            ? (form.createTime = moment(form.createTime).format("MM-DD HH:mm"))
            : (form.createTime = moment(form.createTime).format(
                "YYYY-MM-DD HH:mm"
              ));
        });
        formatDictionary(resp.data.Data.data, resp.data.Data.dictionary);
        this.loading = false;
        this.refreshing = false;
        this.list = [...this.list, ...resp.data.Data.data];
        let that = this;
        if (this.list.length > 0) {
          for (let i = 0; i < this.list.length; i++) {
            if (!that.list[i].creatableForms) {
              let formRes = await that.getCreatableForms(that.list[i]);
              that.list[i].creatableForms = formRes;
            }
          }
          console.log(that.list);
          // isCreatable
        }
        this.finished = resp.data.Data.total <= this.list.length;
      }
    },
    /**
     *  打开合同详情
     */
    openOrder(id, workflowTemplate, status) {
      if (status === "已保存" || status === "审批中" || status === "审批驳回") {
        this.openForm(id, workflowTemplate);
      } else {
        window.open("/#/order/detail?isHiddenTitle=1&id=" + id);
      }
    },
    /**
     * 打开表单详情
     */
    openForm(id, workflowTemplate) {
      if (workflowTemplate === undefined) {
        this.showTableGrid = true;
        this.tableGridId = id;
      } else if (workflowTemplate === "ec4f846a6db74ec98395554a4c726a0f") {
        window.open(
          "http://mobile.react.tysoft.com/tenant/zhengbao/order/detail?id=" + id
        );
      } else {
        window.open(
          "/wf/form/vsheet/form?workflowTemplateId=" +
            workflowTemplate +
            "&id=" +
            id
        );
      }
    },
    /**
     * 刷新列表
     */
    onRefresh() {
      this.finished = false;
      this.pageIndex = 0;
      this.list = [];
      this.getFormDataListByCustomerId();
    },
    /**
     * 获取当前单据可创建的其他表单
     * @param uuid
     * @returns {Promise<void>}
     */
    async getCreatableForms(form) {
      let resp = await formsService.getCreatableForms(
        this.dynamicTabId,
        this.customerId,
        form.uuid
      );
      if (resp.data.Status === "1") {
        let dynamicTabList = resp.data.Data;
        for (const item of dynamicTabList) {
          let resp = await formsService.getFormParameter(
            item.uuid,
            this.customerId,
            form.uuid,
            this.dynamicTabId
          );
          if (resp.data.Status === "1") {
            form[item.uuid] = resp.data.Data;
          }
        }
        return dynamicTabList;
      }
      return [];
    },
    cancel() {
      this.showTableGrid = false;
    },
    /**
     * 从当前表单上新建其他单子
     */
    async createForm(workflowTemplateId, params, e) {
      e.stopPropagation();
      window.open(
        "/wf/form/vsheet/form?workflowTemplateId=" +
          workflowTemplateId +
          "&id=0&customerId=" +
          this.customerId +
          "&advisorId=" +
          this.userId +
          (params || "")
      );
    },
  },
};
</script>
<style scoped>
table td {
  width: 33%;
  height: 1.5rem;
}

.btn-create-from {
  margin-left: 0.3rem;
  margin-bottom: 0.3rem;
}

.td-btn-container {
  text-align: right;
  height: auto;
}

.card {
  padding: 0.5rem 1rem 0.2rem;
}
</style>
